export function mapAccountRejectedOrganizationsRowsToRequest(violations) {
    return violations.reduce((rows, row) => {
        if (!rows[row.accountId]) {
            rows[row.accountId] = [];
        }
        rows[row.accountId].push(...row.organizations.map((org) => org.id));
        return rows;
    }, {});
}
